import React, { useState } from 'react';
import './AdminSidebar.css';
import { 
  HomeIcon, 
  UsersIcon, 
  DocumentIcon, 
  SchoolIcon, 
  CalendarIcon, 
  GraduationIcon, 
  BookIcon, 
  TheaterIcon, 
  RocketIcon, 
  NewsIcon, 
  ChatIcon, 
  MoneyIcon, 
  QuestionIcon 
} from './Icons';

function AdminSidebar({ activePage }) {
  const [expandedMenus, setExpandedMenus] = useState({
    eleves: false,
    enseignants: false,
    classes: false,
    opportunites: false
  });

  const toggleMenu = (menu) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  const navigate = (page) => {
    if (window.navigateTo) {
      window.navigateTo(page);
    }
  };

  const userEmail = (localStorage.getItem('user_email') || '').toLowerCase().trim();
  const userRole = (localStorage.getItem('user_role') || '').toLowerCase().trim();
  const isPrincipalAdmin = !userEmail || userEmail === 'admin@palmiers.com' || userEmail === 'admin' || userRole === 'super_admin';

  return (
    <aside className="admin-sidebar">
      <nav className="sidebar-nav">
        <a 
          href="#dashboard" 
          className={`nav-item ${activePage === 'admin-dashboard' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('admin-dashboard'); }}
        >
          <span className="nav-icon"><HomeIcon size={20} color="currentColor" /></span>
          Tableau de bord
        </a>

        {/* Uniquement visible par l'administrateur principal */}
        {isPrincipalAdmin && (
          <a 
            href="#administrateurs" 
            className={`nav-item ${activePage === 'gestion-administrateurs' ? 'active' : ''}`}
            onClick={(e) => { e.preventDefault(); navigate('gestion-administrateurs'); }}
          >
            <span className="nav-icon">🛡️</span>
            Gestion des administrateurs
          </a>
        )}
        
        <a 
          href="#eleves" 
          className={`nav-item ${activePage === 'gestion-eleves' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-eleves'); }}
        >
          <span className="nav-icon"><UsersIcon size={20} color="currentColor" /></span>
          Gestion des élèves
        </a>

        <a 
          href="#inscriptions" 
          className={`nav-item ${activePage === 'nouvelles-inscriptions' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('nouvelles-inscriptions'); }}
        >
          <span className="nav-icon"><DocumentIcon size={20} color="currentColor" /></span>
          Nouvelles inscriptions
        </a>

        <a 
          href="#enseignants" 
          className={`nav-item ${activePage === 'gestion-enseignants' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-enseignants'); }}
        >
          <span className="nav-icon">👨‍🏫</span>
          Gestion des enseignants
        </a>

        <a 
          href="#attribution-classes" 
          className={`nav-item ${activePage === 'attribution-classes' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('attribution-classes'); }}
        >
          <span className="nav-icon">🎯</span>
          Attribution des classes
        </a>

        <a 
          href="#classes" 
          className={`nav-item ${activePage === 'gestion-classes' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-classes'); }}
        >
          <span className="nav-icon"><SchoolIcon size={20} color="currentColor" /></span>
          Gestion des classes
        </a>

        <a 
          href="#emploi" 
          className={`nav-item ${activePage === 'admin-emploi-du-temps' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('admin-emploi-du-temps'); }}
        >
          <span className="nav-icon"><CalendarIcon size={20} color="currentColor" /></span>
          Emploi du temps
        </a>

        <a 
          href="#opportunites" 
          className={`nav-item ${activePage === 'gestion-stages' || activePage === 'gestion-bourses' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); toggleMenu('opportunites'); }}
        >
          <span className="nav-icon"><GraduationIcon size={20} color="currentColor" /></span>
          Stages & Bourses
          <span className={`dropdown-arrow ${expandedMenus.opportunites ? 'expanded' : ''}`}>›</span>
        </a>
        {expandedMenus.opportunites && (
          <div className="submenu">
            <a 
              href="#stages" 
              className={`nav-item submenu-item ${activePage === 'gestion-stages' ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); navigate('gestion-stages'); }}
            >
              Stages
            </a>
            <a 
              href="#bourses" 
              className={`nav-item submenu-item ${activePage === 'gestion-bourses' ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); navigate('gestion-bourses'); }}
            >
              Bourses
            </a>
            <a 
              href="#opportunites" 
              className={`nav-item submenu-item ${activePage === 'gestion-opportunites' ? 'active' : ''}`}
              onClick={(e) => { e.preventDefault(); navigate('gestion-opportunites'); }}
            >
              Opportunités
            </a>
          </div>
        )}

        <a 
          href="#filieres" 
          className={`nav-item ${activePage === 'gestion-filieres' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-filieres'); }}
        >
          <span className="nav-icon"><BookIcon size={20} color="currentColor" /></span>
          Filières
        </a>

        <a 
          href="#clubs" 
          className={`nav-item ${activePage === 'gestion-clubs' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-clubs'); }}
        >
          <span className="nav-icon"><TheaterIcon size={20} color="currentColor" /></span>
          Clubs
        </a>

        <a 
          href="#projets" 
          className={`nav-item ${activePage === 'gestion-projets' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-projets'); }}
        >
          <span className="nav-icon"><RocketIcon size={20} color="currentColor" /></span>
          Projets & Cagnottes
        </a>

        <a 
          href="#partenaires" 
          className={`nav-item ${activePage === 'partenaires' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-partenaires'); }}
        >
          <span className="nav-icon">🤝</span>
          Partenaires
        </a>

        <a 
          href="#actualites" 
          className={`nav-item ${activePage === 'gestion-actualites' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-actualites'); }}
        >
          <span className="nav-icon"><NewsIcon size={20} color="currentColor" /></span>
          Actualités
        </a>

        <a 
          href="#messages" 
          className={`nav-item ${activePage === 'gestion-messages' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('gestion-messages'); }}
        >
          <span className="nav-icon"><ChatIcon size={20} color="currentColor" /></span>
          Messages & Contacts
        </a>

        <a 
          href="#rapports-absences" 
          className={`nav-item ${activePage === 'rapports-absences' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('rapports-absences'); }}
        >
          <span className="nav-icon">📋</span>
          Rapports d'absences
        </a>

        <a 
          href="#historique-paiements" 
          className={`nav-item ${activePage === 'historique-paiements' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('historique-paiements'); }}
        >
          <span className="nav-icon"><MoneyIcon size={20} color="currentColor" /></span>
          Historique des paiements
        </a>

        <a 
          href="#support" 
          className={`nav-item ${activePage === 'support' ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); navigate('support'); }}
        >
          <span className="nav-icon"><QuestionIcon size={20} color="currentColor" /></span>
          Support et aides
        </a>
      </nav>
    </aside>
  );
}

export default AdminSidebar;
